<template>
  <router-view></router-view>
</template>

<script>
import MenuList from './MenuList'

export default {
  name: 'my-side-bar-content',
  components: {
    MenuList
  },
  data () {
    return {
      
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/DefaultContent.vue